document.addEventListener('turbolinks:load', () => {
  const notificationDeleteButton = document.getElementById("notification-delete-button")
  if (notificationDeleteButton) {
    notificationDeleteButton.onclick = () => {
      notificationDeleteButton.parentNode.parentNode.parentNode.remove()
    }
  }
})
